import script from "./SkilledPersonSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./SkilledPersonSummary.vue?vue&type=script&setup=true&lang=js"

import "./SkilledPersonSummary.vue?vue&type=style&index=0&id=1cce4cba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cce4cba"]])

export default __exports__